// extracted by mini-css-extract-plugin
export default {"basic-panel":"ModalAddAdmin_basic-panel__Xl4s6","input":"ModalAddAdmin_input__DZ8z6","actions":"ModalAddAdmin_actions__Wuw6f"};